import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=3e5d9d44&scoped=true"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=3e5d9d44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d9d44",
  null
  
)

export default component.exports